<template>
<div style="display: inherit">
  <router-link :to="{ name: 'browse' }" v-if="this.$route.name !== 'browse'" class="navbar-item">
    <b-icon class="is-hidden-desktop menu-icon" icon="table"/>
    {{$t('browse')}}
  </router-link>
</div>
</template>

<i18n src="@/i18n/global.i18n.json"></i18n>

<script>
import i18nMixin from '@/mixins/i18n';

export default {
  name: 'browseAppToolbar',
  mixins: [i18nMixin],
};

</script>





// WEBPACK FOOTER //
// src/components/NewAppToolbar.vue